var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chip',{attrs:{"color":_vm.data ? 'green' : 'red',"text-color":"white"}},[_vm._v("\n    "+_vm._s(_vm.data ? "Медосмотр пройден" : "Медосмотр не пройден")+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }